import React, { useState, useEffect, useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Col, Container, Row, Tab } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import Table from 'react-bootstrap/Table';
import Laoding from '../shared/Laoding';
import ShowError from "../shared/ShowError";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as parameterHelper from '../shared/extraParameterHelper';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";

export default function AllProducts(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [products, setProducts] = useState([]);
    const [searchParams] = useSearchParams();
    const software = searchParams.get("software");

    useEffect(() => {
        var ps = [
            {
                caption:"حسابداری هانا",
                packages:[
                    {
                        "code": "SimpleWinAccounting",
                        "title": "نسخه حسابداری ساده",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "ServiceWinAccounting",
                        "title": "نسخه حسابداری خدماتی",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "BusinesseWinAccounting",
                        "title": "نسخه حسابداری فروشگاهی/بازرگانی",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "VisitoryWinAccounting",
                        "title": "نسخه ویزیتوری (پخش سرد و گرم )",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "BarFrooshiWinAccounting",
                        "title": "نسخه میادین میوه و تره بار (بار فروشی)",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "ResturantWinAccounting",
                        "title": "نسخه رستوران و اغذیه فروشی",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "WorkersWinAccounting",
                        "title": "نسخه خدمات تامین نیرو",
                        "link":"product/win-accounting",
                    },
                    {
                        "code": "ProductWinAccounting",
                        "title": "تولیدی",
                        "link":"product/win-accounting",
                    }
                ]
            },
            {
                caption:"حسابداری و مدیریت مالی مدارس",
                packages:[
                    {
                        "code": "independent_school",
                        "title": "مدرسه مستقل",
                        "link":"product/school-accounting",
                    },
                    {
                        "code": "complex_school",
                        "title": "مجتمع های آموزشی با چند مدرسه تابعه",
                        "link":"product/school-accounting",
                    },
                ]
            },
            {
                caption:"ارسال صورتحساب به سامانه مودیان مالیاتی",
                packages:[
                    {
                        "code": "TaxService",
                        "title": "ادارات، سازمان ها و شرکت ها",
                        "link":"product/tax-service",
                    },
                ]
            },
            {
                caption:"صندوقهای وام قرض الحسنه و اعتبار",
                packages:[
                    {
                        "code": "AllLoanCenter",
                        "title": "ادارات، سازمان ها و شرکت ها",
                        "link":"product/loan-center",
                    },
                ]
            },
            {
                caption:"سامانه صدور گواهی کسر حقوق کارکنان",
                packages:[
                    {
                        "code": "SalaryCertificate",
                        "title": "ادارات، سازمان ها و شرکت ها",
                        "link":"product/salary-certificate",
                    },
                ]
            },
        ];
        setProducts(ps);
        for(var i=0;i<ps.length;i++){
            for(var j=0;j<ps[i].packages.length;j++){
                if(ps[i].packages[j].code == software){
                    navigate("/" + ps[i].packages[j].link);
                }
            }
        }
    }, []);
    return (
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        <>
            {
                products.map((pg, pgInd)=>{
                    return(
                        <Row style={{margin:"30px 0px", padding:"0px 0px 0px 0px", position:"relative"}}>
                            <div style={{height:"3px", width:"100%",backgroundColor:"#993030"}}></div>
                            <span style={{position:"absolute", top:"-14px", right:"15px", backgroundColor:"#fff", width:"380px", fontSize:"14pt", fontWeight:"bold"}}>{pg.caption}</span>
                            {
                                pg.packages.map((p, pInd)=>{
                                    return(
                                        <Col md="3" style={{margin:"20px 0px 0px 0px", padding:"5px", boxSizing:"border-box"}}>
                                            <table style={{width:"100%", cursor:"pointer"}} onClick={()=>navigate(config.Client+"/"+p.link+"?software=" + p.code,{})}>
                                                <tbody>
                                                    <tr><td style={{textAlign:"center"}}><img src={require('../lib/products/webp/'+p.code+'.webp')} style={{borderRadius:"10px", width:"calc(100% - 20px)"}} alt={p.title}/></td></tr>
                                                    <tr><td style={{textAlign:"center"}}>{p.title}</td></tr>
                                                </tbody>
                                            </table>
                                            
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    )
                })
            }
        </>

    )
}
